export default __webpack_public_path__ + "static/media/avatar10.ec923dc9.png";